import { PartnersSection } from './PartnersSection'
import { getLocale } from '../../helpers/localization'
import { AnimocaLogo, GemsLogo, HighstreetLogo, HookedLogo, MocaverseLogo, ForbedWeb3Logo, TinyLogo, NewCampusLogo, ApeCoinLogo, BinanceLogo, RiseInLogo, HackQuestLogo } from '../../assets/logos/partners-colored';
import LaunchPartners from '../../assets/images/partners-page/launch-partners-small.svg'
import { PARTNERS_LINKS, PUBLISHER_NFT } from '../../constants'
import './PartnersPage.scss';
import { Container } from 'react-bootstrap';


const localization = getLocale()

export const PartnersPage = () => {
  return (
    <Container id='partners-page'>
      <h1><span className='pp1'>Strategic</span> <span className='pp2'>Partners</span></h1>
      <h2 style={{color: '#07094D', textAlign: 'center'}}>A Shared Vision for the Future of Educations</h2>
      <div className='partners'>
        {PARTNERS_DATA.map((data, i) => {
          return (
            <PartnersSection
              key={i}
              title={data.title}
              text={data.text}
              link={data.link}
              logo={data.logo}
              category={data.category}
            />
          )
        })}
      </div>
    </Container>
  )
}

const TinyTapTextComponent = ({ textArr }) => {
  return (
    <>
      {textArr[0]}
      <a href={`${PARTNERS_LINKS.tinytapNft}`} rel="noreferrer" target="_blank">
        {PUBLISHER_NFT}
      </a>
      {textArr[1]}
    </>
  )
}

const TINYTAP_TEXT = () => {
  const textArr = localization.tinytapDescription.split(PUBLISHER_NFT)
  if (textArr.length === 2) {
    return <TinyTapTextComponent textArr={textArr} />
  }

  return localization.tinytapDescription
}

const PARTNERS_DATA = [
  {
    title: localization.tinytap,
    text: "TinyTap is a pioneering platform that allows educators, parents, and students to create and share interactive educational games and lessons. It enables personalized learning by empowering users to craft unique, engaging content that suits individual learning needs, making education both accessible and fun.",
    logo: { src: TinyLogo, heightMobile: 84, widthMobile: 84, widthDesktop: 172, heightDesktop: 172 },
    link: 'https://tinytap.com',
    eventLabel: 'tinytap',
    category: 'Learning Platform',
  },
  {
    title: localization.animocaBrands,
    text: localization.animocaBrandsDescription,
    logo: { src: AnimocaLogo, heightMobile: 68, widthMobile: 114, widthDesktop: 404, heightDesktop: 164 },
    link: 'https://animocabrands.com',
    eventLabel: 'animoca',
    category: 'Technology',
  },
  {
    title: "binance",
    text: "Binance is a premier global cryptocurrency exchange that provides a secure platform for trading digital assets. With a wide range of services, Binance facilitates the buying, selling, and storage of cryptocurrencies, driving the widespread adoption of blockchain technology across the entire financial industry, fostering innovation.",
    logo: {src: BinanceLogo, heightMobile: 84, widthMobile: 84, widthDesktop: 172, heightDesktop: 172},
    link: 'https://binance.com',
    category: 'Technology',
  },
  {
    title: "ApeCoin",
    text: "ApeCoin is a decentralized cryptocurrency that fuels the evolution of art, gaming, and community-driven experiences in the metaverse. By connecting creators and enthusiasts, ApeCoin provides a platform that incentivizes innovation and collaboration, paving the way for the next generation of digital culture.",
    logo: {src: ApeCoinLogo, heightMobile: 84, widthMobile: 84, widthDesktop: 172, heightDesktop: 172},
    link: 'https://apecoin.com',
    category: 'Technology',
  },
  {
    title: "New Campus",
    text: "NewCampus is a modern learning hub designed for the future of work. Offering leadership and business education through flexible, engaging courses, NewCampus empowers professionals at all levels to adapt and thrive in a rapidly evolving global landscape, fostering lifelong learning and personal growth.",
    logo: {src: NewCampusLogo, heightMobile: 84, widthMobile: 84, widthDesktop: 172, heightDesktop: 172},
    link: 'https://newcampus.com',
    category: 'Learning Platform',
  },
  {
    title: "Rise In",
    text: "RiseIn connects individuals with industry experts who provide personalized mentorship and career guidance. Through a combination of one-on-one sessions, workshops, and career planning tools, RiseIn offers tailored advice and actionable insights. This  support helps users navigate their professional journeys.",
    logo: {src: RiseInLogo, heightMobile: 84, widthMobile: 84, widthDesktop: 172, heightDesktop: 172},
    link: 'https://risein.com',
    category: 'Institution',
  },
  {
    title: "Gems",
    text: "GEMS Education is a global leader in private K-12 schooling, operating a network of high-quality educational institutions. With a focus on academic excellence and innovation, GEMS provides students with diverse curricula that prepare them for success in an increasingly interconnected and competitive global environment.",
    logo: {src: GemsLogo, heightMobile: 84, widthMobile: 84, widthDesktop: 172, heightDesktop: 172},
    link: 'https://gemseducation.com',
    category: 'Institution',
  },
  {
    title: "ForbesWeb3",
    text: "Forbes is a globally recognized media company known for its authoritative coverage of business, technology, and leadership. Providing in-depth insights, news, and analysis, Forbes influences the global business landscape and empowers readers with the knowledge needed to succeed in their professional endeavors.",
    logo: {src: ForbedWeb3Logo, heightMobile: 84, widthMobile: 84, widthDesktop: 172, heightDesktop: 172},
    link: 'https://forbes.com',
    category: 'Media',
  },
  {
    title: "HackQuest",
    text: "HackQuest is a multi-chain Web3 developer and founder platform home to 65k+ developers from 180+ countries, with education, community events, hackathons, and accelerators at its core. HackQuest helps over 20 leading ecosystems such as Mantle, Solana, Arbitrum, Linea, and EDU Chain onboard quality developers and supports developers to jumpstart their careers in Web3.",
    logo: {src: HackQuestLogo, heightMobile: 84, widthMobile: 84, widthDesktop: 172, heightDesktop: 172},
    link: 'https://hackquest.io',
    category: 'Technology',
  },
]

